import { EMAIL_REGEX } from '@constants/common';
import { IntlShape } from 'react-intl';
import * as Yup from 'yup';

const getUnauthenticatedFormSchema = (intl: IntlShape) =>
    Yup.object({
        first_name: Yup.string().required(intl.formatMessage({ id: 'error.required', defaultMessage: 'Required' })),
        last_name: Yup.string().required(intl.formatMessage({ id: 'error.required', defaultMessage: 'Required' })),
        email: Yup.string()
            .trim()
            .matches(EMAIL_REGEX, intl.formatMessage({ id: 'error.invalidEmail', defaultMessage: 'Invalid email' }))
            .email(intl.formatMessage({ id: 'error.invalidEmail', defaultMessage: 'Invalid email' }))
            .required(intl.formatMessage({ id: 'error.required', defaultMessage: 'Required' })),
        company_name: Yup.string().required(intl.formatMessage({ id: 'error.required', defaultMessage: 'Required' })),
        country_code: Yup.string().required(intl.formatMessage({ id: 'error.required', defaultMessage: 'Required' })),
    });

export default getUnauthenticatedFormSchema;
